export default "__VITE_ASSET__BlTbAgUD__"